import React, { useContext } from 'react';
import { setAuthToken, resetAuthErrorModal } from '../../services/api';
import { AuthContext } from '../../context/AuthContext';
import { useHistory } from 'react-router-dom';

const AuthErrorModal = ({ isOpen, onClose }) => {
  const { setUser } = useContext(AuthContext);
  const history = useHistory();
  if (!isOpen) return null;

  const handleLogin = () => {
    localStorage.setItem('authErrorLogout', 'true');
    localStorage.removeItem('token');
    sessionStorage.removeItem('token');
    
    setAuthToken(null);
    
    if (typeof resetAuthErrorModal === 'function') {
      resetAuthErrorModal();
    }
    
    setUser(null);
    
    onClose();
    
    setTimeout(() => {
      history.push('/login');
      
      setTimeout(() => {
        localStorage.removeItem('authErrorLogout');
      }, 500);
    }, 100);
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black opacity-50"></div>
      <div className="bg-white rounded-lg p-6 max-w-md w-full z-10 relative shadow-xl">
        <div className="text-center">
          <div className="mb-4 flex justify-center">
            <svg className="h-12 w-12 text-blue-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
          </div>
          
          <h3 className="text-xl font-medium text-gray-900 mb-3">
            Session Expired
          </h3>
          
          <p className="text-gray-600 mb-5">
           Your session has expired. Please log in again to continue working.
          </p>
          
          <div className="flex justify-center space-x-4">
            <button
              onClick={handleLogin}
              className="bg-blue-500 hover:bg-blue-600 text-white font-medium py-2 px-4 rounded-md"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthErrorModal;